export default __webpack_public_path__ + "static/media/CJavaScript.ce177e82.jpg";